import styled from '@marvelapp/styled';
import { Box } from '@marvelapp/ui';
const Divider = styled(Box).attrs((props) => (Object.assign({ bg: 'slate6', mt: 's', mb: 's' }, props))) `
  height: 1px;
`;
export default Divider;
